// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__25Uua","errorLogs":"EditorFooter_errorLogs__GH3nG"};